/*
 * Prevent scrolling when the hyperlink popover is open.
 * Below solution is a workaround that prevents scrolling, including keyboard, mouse, and touchpad.
 * */
import React from 'react';

const preventDefault = (e: Event): void => e.preventDefault();

export const usePreventScrolling = (isHyperlinkPopoverOpen: boolean) => {
  React.useEffect(() => {
    if (isHyperlinkPopoverOpen) {
      // Setting passive to false tells the browser that the event listener will call preventDefault.
      // Otherwise, the browser will ignore preventDefault and scroll anyway.
      document.addEventListener('wheel', preventDefault, { passive: false });
      document.addEventListener('touchmove', preventDefault, {
        passive: false,
      });
    } else {
      document.removeEventListener('wheel', preventDefault);
      document.removeEventListener('touchmove', preventDefault);
    }

    return () => {
      document.removeEventListener('wheel', preventDefault);
      document.removeEventListener('touchmove', preventDefault);
    };
  }, [isHyperlinkPopoverOpen]);
};
